import { OrgSupplier, OrgSupplierLite, PublicSupplier } from 'types/suppliers';
import { useSelector } from 'store';
import { Stack, Typography } from '@mui/material';
import { actionButtonSpacing } from 'constants/themeConstants';
import SupplierLogoAvatar from 'ui-component/SupplierLogo/SupplierLogoAvatar';
import InlineGoToButton from 'ui-component/shared/InlineGoToButton';
import _ from 'lodash';
import { ALL_VIEWS } from 'constants/appConstants';

const SupplierInfoWidget = ({
  supplier,
}: {
  supplier: OrgSupplier | PublicSupplier | OrgSupplierLite;
}) => {
  const { activeOrgId } = useSelector((state) => state.org);
  return (
    <Stack
      direction="row"
      spacing={actionButtonSpacing}
      sx={{
        justifyContent: 'flex-start',
        alignItems: 'center',
        m: 2,
      }}
    >
      <SupplierLogoAvatar supplier={supplier} />
      <Stack
        direction="column"
        sx={{
          justifyContent: 'center',
          alignItems: 'flex-start',
        }}
      >
        <Typography variant="h5">{supplier.name}</Typography>
        <Typography variant="caption">{supplier.website}</Typography>
      </Stack>
      {!!_.get(supplier, 'org') && (
        <InlineGoToButton
          link={`${ALL_VIEWS.SUPPLIERS.path}/${supplier.id}?activeorgid=${activeOrgId}`}
          recordName="Supplier"
        />
      )}
    </Stack>
  );
};

export default SupplierInfoWidget;
